module.exports = __webpack_public_path__ + "img/tork.5792a85f.png";